// src/auth/AdminGuard.jsx
//
// Phase 2 Sprint 1: Admin route guard SKELETON.
// Per P7: handles promise rejection + cancellation; resets isAdmin on currentUser change.
// Per AG18: this is the ONLY frontend admin authority check; backend Cloud Functions
// must independently verify admin claim per defense-in-depth (Phase 2 Sprint 5+).
// Per AG14: AdminGuard is skeleton only; admin features themselves are NOT built this sprint.

import React from 'react';
import { useStaffAccess } from './useStaffAccess.js';

export const AdminGuard = ({ children }) => {
    const access = useStaffAccess();
    const isAdmin = access.admin || access.permissions.length > 0;
    if (access.loading) return null;
    if (!isAdmin) return (
        <div className="page-fade-in min-h-[calc(100vh-4rem)] bg-burgundy-bg paper-texture">
            <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-16 text-center">
                <h1 className="font-display text-burgundy-text text-3xl mb-4">Access denied</h1>
                <p className="font-serif italic text-burgundy-muted mb-8">
                    This page requires administrator privileges.
                </p>
            </div>
        </div>
    );
    return children;
};
